import { useState, useEffect } from "react";
import styles from "./NowTimeBar.module.css";

const NowTimeBar = () => {
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date().toLocaleTimeString("ko-KR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      setCurrentTime(now);
    };

    updateTime(); // 초기 시간 설정
    const interval = setInterval(updateTime, 1000); // 1초마다 업데이트

    return () => clearInterval(interval); // 클린업
  }, []);

  return <div className={styles.nowTime}>(현재 시간) {currentTime}</div>;
};
export default NowTimeBar;
